import { useLang } from "@/i18n/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const ITEMS = t("marquee");
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-quote-marquee"
      className="overflow-hidden border-y py-5"
      style={{ borderColor: "var(--border-delicate)", backgroundColor: "var(--bg-surface)" }}
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className="font-display px-8 text-2xl font-light italic tracking-wide sm:text-3xl"
                  style={{ color: "var(--text-muted)" }}
                >
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: "var(--accent-gold)" }} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
